import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SemCreativeCardV3Component } from './../sem-creative-card-v3/sem-creative-card-v3.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import * as _ from 'underscore';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-sem-creative-card-v4',
	templateUrl: './sem-creative-card-v4.component.html',
	styleUrls: ['./sem-creative-card-v4.component.css']
})
export class SemCreativeCardV4Component extends SemCreativeCardV3Component implements OnInit, OnDestroy {
	public creative: any;
	public topAdsFields: any = { data: [], columns: [] };
	public topAds = [];
	public currentAd = [];
	public currentCreative = {};
	public tableConfig: DataTableConfig = <DataTableConfig>{};
	public columnConfig: any;
	public currentAdIndex: any;
	range: string;
	semGoLiveDate: string;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.showLoad = true;
			this.requestData();
		});
	}

	ngOnInit() {
		this.showLoad = true;
		this.columnConfig = JSON.parse(decodeURI(this.datatableconfig));
		const dateSet = {
			startDate: this.analyticsDataModel.startDate,
			endDate: this.analyticsDataModel.endDate,
			depricatedDate: this.analyticsDataModel.depricatedDate
		};
		this.topAdsFields.columns = UtilityService.checkForVisibilityPermissions(this.columnConfig.columns, dateSet);
		this.currentAdIndex = this.topAdsFields.columns.slice(1)[0].columnKey;
		this.requestData();
		super.ngOnInit();
	}

	requestData() {
		const dateSet = {
			startDate: this.analyticsDataModel.startDate,
			endDate: this.analyticsDataModel.endDate,
			depricatedDate: this.analyticsDataModel.depricatedDate,
			goLiveDate: this.analyticsDataModel.goLiveDate
		};
		this.topAdsFields.columns = UtilityService.checkForVisibilityPermissions(this.columnConfig.columns, dateSet);
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			this.topAdsFields.data = [];
			if (res.success) {
				this.hasData = true;
				this.analyticsService.checkDateRange();
				this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
				this.isCutoffDate = this.analyticsService.isCutoffDate;
				this.processResponseData(res.data);
				this.processAdsData(res.data);
				this.currentAd = this.topAds[this.currentAdIndex];
			} else {
				this.hasData = false;
				this.topAdsFields.data = [];
				this.creatives = [];
				this.totalCreatives = 0;
			}
		});
		if (typeof this.datatableconfig === 'string') {
			this.tableConfig = JSON.parse(decodeURI(this.datatableconfig));
		} else {
			this.tableConfig = this.datatableconfig;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
	updateCreative(index) {
		this.currentCreative = this.creatives[index];
	}
	updateAds(event) {
		this.currentAdIndex = event;
		this.currentAd = this.topAds[event];
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.currentCreative = this.creatives[0];
		} else {
			this.hasData = false;
		}
	}
	processAdsData(data) {
		this.topAdsFields.columns.forEach((ad) => {
			if (ad.columnKey !== 'ad_headline') {
				this.topAds[ad.columnKey] = [];
				data.forEach((element) => {
					const obj = {
						title: UtilityService.isUndefinedOrNull(element.ad_headline) ? ' ' : element.ad_headline,
						value: Number(element[ad.columnKey]),
						type: ad.columnKey,
						name: ad.columnName
					};
					this.topAds[ad.columnKey].push(obj);
				});
			}
			this.topAds[ad.columnKey] = _.sortBy(this.topAds[ad.columnKey], 'value').reverse();
		});
	}

	getBarPercentage(percentage) {
		if (this.currentAd[0].value == 0) {
			return { width: '0%' };
		}
		return { width: `${Math.floor((percentage / this.currentAd[0].value) * 100)}%` };
	}
}
